import CurriculumBox from "../../content/Curricula/CurriculumBox/CurriculumBox";
import { Fragment, useEffect, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ICurriculaBox } from "../../content/Curricula/CurriculumBox/CurriculumBoxProps";
import CurriculumSkeleton from "../../content/Curricula/CurriculumSkeleton/CurriculumSkeleton";
import "./Curricula.scss";
import usersService from "../../../Axios/services/users.service";
import { setCurriculas } from "../../../store/actions/curriculaActions";


const Curricula = () => {
  const dispatch = useDispatch();
  const { me } = useSelector((state: any) => state.auth); 
  const { curriculas } = useSelector((state: any) => state.curricula); 
  const [itemList, setItemList] = useState<{ [key: string]: ICurriculaBox[] }>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [t] = useTranslation("common");

  useEffect(() => {
    if (me ){
      fetchCurricula();
    }
     
  }, [me]);
  

  const fetchCurricula = async () => {
    setLoading(true);
    try {
      let curriculasList = curriculas
  
      if (!curriculasList){
        curriculasList = await usersService.getCurriculaByUserId(me?._id);
        dispatch(setCurriculas(curriculasList));
      }

      if (curriculasList && curriculasList.curriculumData) {
        const groupedBySeries = curriculasList.curriculumData.reduce((acc, { entityStatus, entityTemplates, entityTitle, _id, entityTeams = [], entityParticipants = [], entityTeamCount, entityParticipantCount, series, createdDate }) => {
          if (entityStatus !== "Live") return acc;

          const templateId = entityTemplates?.[0]?.templateId || null;
          const seriesKey = series || "Others";

          const curriculum = {
            templateId,
            templateTitle: entityTitle,
            entityId: _id,
            entityTitle,
            numOfTeam: entityTeamCount ?? (entityTeams || []).length,
            numOfParticipants: entityParticipantCount ?? (entityParticipants || []).length,
            series: seriesKey,
            createdDate: new Date(createdDate),
          };

          acc[seriesKey] = acc[seriesKey] || [];
          acc[seriesKey].push(curriculum);

          return acc;
        }, {} as { [key: string]: ICurriculaBox[] });

        // Sort each series by createdDate (newest first)
        Object.keys(groupedBySeries).forEach(seriesKey => {
          groupedBySeries[seriesKey].sort((a, b) => {
            const dateA = (a as any).createdDate?.getTime() || 0;
            const dateB = (b as any).createdDate?.getTime() || 0;
            return dateB - dateA; // Descending order (newest first)
          });
        });

        setItemList(groupedBySeries);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const renderCurricula = () => {
    if (Object.keys(itemList).length === 0) {
      return <div className="mx-md-0 mb-y px-md-0 px-0 px-md-3">You don't have any curriculum yet.</div>;
    }

    const sortedSeries = Object.keys(itemList).sort((a, b) => {
      if (a === "Others") return 1;
      if (b === "Others") return -1;
      return a.localeCompare(b);
    });

    return (
      <Fragment>
        <div className="mx-md-0 my-4">
          <div className="title">{t("Curricula")}</div>
        </div>
        <div className="d-flex flex-column">
          {sortedSeries.map((series) => (
            <div key={series} className="seriesGroup">
              <h4 className="seriesTitle">{series}</h4>
              {itemList[series].map((c: ICurriculaBox) => (
                <div key={c.entityId} className="">
                  <CurriculumBox curricula={c} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </Fragment>
    );
  };

  return <div className="my-curricula container-fluid px-md-3 px-sm-3">{loading ? <CurriculumSkeleton /> : renderCurricula()}</div>;
};

export default Curricula;
